import logo from './logo.svg';
import './App.css';
import BasicLoginForm from './components/common/BasicLoginForm';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Lorem Ipsum Dolor Sit Amet
        </p>
        <p>{process.env.REACT_APP_ENV_CMD_TEST_STRING}</p>
        <BasicLoginForm />
      </header>
    </div>
  );
}

export default App;
